import { useState, useEffect } from "react";
import { useLikedMedia } from "@/hooks/useLikedMedia";

interface UseLightboxLikeOptions {
  mediaUrl: string;
  mediaType: "image" | "video";
  thumbnailUrl: string;
  referenceImageUrl?: string;
  prompt?: string;
}

export function useLightboxLike({
  mediaUrl,
  mediaType,
  thumbnailUrl,
  referenceImageUrl,
  prompt,
}: UseLightboxLikeOptions) {
  const { isLiked, toggleLike } = useLikedMedia();
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    setLiked(isLiked(mediaUrl));
  }, [mediaUrl, isLiked]);

  const handleToggleLike = async () => {
    const newLikedState = await toggleLike(mediaUrl, mediaType, {
      thumbnailUrl,
      referenceImageUrl,
      prompt,
    });
    setLiked(newLikedState);
  };

  return { liked, handleToggleLike };
}
